<div class="container-fluid">
  <div class="row">
    <div *ngIf='screenWidth > 991'>
      <div (window:resize)="screenRotate($event)" (window:orientationchange)="screenRotate($event)">
        <div class="bmw-header-lg-rectangle" [style]="setBackgroundStyle">
          <div class="header-title">
            <img class="bmw-header-lg-logo" [src]='imgSrc' />
            <div class="bmw-lg-technical-information">Technical Information System</div>
          </div>
          <div class="header-search-options">
            <div class="dropdown bmw-no-gutter">
              <div class="btn dropdown-toggle bmw-header-lg-dropdown" data-toggle="dropdown">
                {{searchSectionDisplay}}&nbsp;
                <span class="caret"></span>
              </div>
              <ul class="dropdown-menu bmw-dropdown-background" style="width:300px">

                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('SIB')">
                    <div>Service Bulletins (SIB)</div>
                  </div>
                </li>
                <li>
                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TM')">
                    <div>Training Manuals (TM)</div>
                  </div>
                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('FAQ')">
                    <div>FAQ & Top Links (FAQ)</div>
                  </div>
                </li>
                <li>
                  <div *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" class="pointer bmw-lg-dropdown-radio"
                    (click)="selectValue('OBD')">
                    <div>OBD</div>
                  </div>
                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TE')">
                    <div>Tools & Equipment (T&E)</div>
                  </div>
                </li>
                <li *ngIf="isExternal == 'false'">
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TD')">
                    <div>Technical Documentation (TD)</div>
                  </div>
                </li>
                <li>
                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('All')">
                    <div>All</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="bmw-no-gutter navbar-form" role="search">
              <form class="input-group" name="searchBulletins">
                <input type="text" spellcheck="true" class="form-control" [(ngModel)]='search_key'
                  (keyup.enter)="searchKeyword(search_section)" size=55 placeholder="Search" name="srch-term"
                  id="srch-term1">
                <div class="input-group-btn">
                  <button class="btn btn-default bmw-header-lg-dropdown" type="button"
                    (click)="searchKeyword(search_section)" [disabled]='search_key?.trim().length < 1'>
                    <i class="material-icons md-10">search</i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="header-buttons">
            <img *ngIf="is3rdParty" src="assets/images/parts24logo.png" alt="Parts24 Logo" style="max-width: 120px; max-height: 40px; margin-right: 20px; cursor: pointer;" (click)="openParts24Link()">
            <a class="header-button-with-icon" [routerLink]='["/model-map"]'>
              <div class="bmw-material-icons">
                <div *ngIf='showCar && !showBike' class="material-icons">directions_car</div>
                <div *ngIf='showBike && !showCar' class="material-icons">directions_bike</div>
              </div>
              <div class="bmw-header-controls-right">Model Map</div>
            </a>
            <a class="header-button-with-icon" [routerLink]='["/profile"]'>
              <div class="bmw-material-icons">
                <div class="material-icons">account_box</div>
              </div>
              <div class="bmw-header-controls-right">Profile</div>
            </a>
            <a *ngIf="isExternal == 'true'" [routerLink]='["/logout"]' (click)='clearUserSessions()'>
              <div class="bmw-material-icons">
              </div>
              <div class="bmw-header-controls-right">Logout</div>
            </a>
            <div *ngIf='hideNavbar'>
              <div class="bmw-header-controls-right pointer" [routerLink]='["/login"]'>Login</div>
            </div>
          </div>
        </div>
        <app-navbar></app-navbar>

      </div>
    </div>
    <div *ngIf='screenWidth >= 767 && screenWidth < 991'>
      <div (window:resize)="screenRotate($event)" class="visible-md" (window:orientationchange)="screenRotate($event)">
        <div class="bmw-navbar-md-rectangle" [style]="setBackgroundStyle">
          <nav class="navbar bmw-nav">
            <ul class="nav navbar-nav navbar-left">
              <li>
                <a routerLink="/home">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Home </span>
                </a>
              </li>
              <li class="dropdown">
                <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Service Information </span>
                  <b class="caret" [style]="setFontStyle"></b>
                </a>
                <ul class="dropdown-menu bmw-dropdown-background">
                  <li>
                    <a [routerLink]='["/sib-home"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Service Bulletins</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]='["/tri-home"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">{{bulletinLabel}}</span>
                    </a>
                  </li>
                  <li *ngIf="APP_SETTINGS.isMINI == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
                    <a [routerLink]='["/operating-fluid"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Operating Fluids</span>
                    </a>
                  </li>
                  <li *ngIf="APP_SETTINGS.isMOTORRAD == 'false'">
                    <a [routerLink]='["/obd"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">OBD</span>
                    </a>
                  </li>
                  <li *ngIf="APP_SETTINGS.isRollsRoyce == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
                    <a [routerLink]='["/legacy"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Legacy</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li *ngIf="isExternal == 'false'" class="dropdown">
                <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle"> Parts Information </span>
                  <b class="caret" [style]="setFontStyle"></b>
                </a>
                <ul class="dropdown-menu bmw-dropdown-background">
                  <li>
                    <a [routerLink]='["/parts-home"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Parts Bulletins</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li class="dropdown">
                <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle"> Training </span>
                  <b class="caret" [style]="setFontStyle"></b>
                </a>
                <ul class="dropdown-menu bmw-dropdown-background">
                  <li>
                    <a [routerLink]='["/tech-training-manual"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Technical Training Manuals</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]='["/body-paint-manual"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Body & Paint Manuals</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li class="dropdown">
                <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle"> Tools & Equipment </span>
                  <b class="caret" [style]="setFontStyle"></b>
                </a>
                <ul class="dropdown-menu bmw-dropdown-background">
                  <li>
                    <a [routerLink]='["/equip-manual"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Equipment Manuals</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]='["/tool-report"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">Tool Report</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]='["/faq"]'>
                      <span class="bmw-dropdown-content bmw-font-size-12">FAQ & Top Links</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <a routerLink="/videos">
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Videos </span>
                </a>
              </li>
              <li *ngIf='isCar'>
                <a [routerLink]='["/takata-recall"]'>
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Takata Recall </span>
                </a>
              </li>

              <li *ngIf="isExternal == 'false'">
                <a [routerLink]='["/tech-doc"]'>
                  <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Technical Documentation </span>
                </a>
              </li>

            </ul>
          </nav>
        </div>

      </div>

      <div (window:resize)="screenRotate($event)" class="visible-sm" (window:orientationchange)="screenRotate($event)">

        <nav class="navbar" style="margin:0px">
          <div class="container-fluid" style="padding: 0px;">
            <div class="navbar-header">
              <div class="row bmw-no-gutter" [style]="setBackgroundStyle">
                <div class="col-sm-2">
                  <button type="button" class="navbar-toggle pull-left" data-toggle="collapse" #navbar
                    data-target=".navbar-collapse">
                    <span class="icon-bar" style="background-color:white"></span>
                    <span class="icon-bar" style="background-color:white"></span>
                    <span class="icon-bar" style="background-color:white"></span>
                  </button>
                </div>
                <div class="col-sm-8">
                  <div style="padding-left:30%">
                    <div class="navbar-brand bmw-header-sm-logo"
                      [ngClass]='{"mini-logo-small": APP_SETTINGS.isMINI === "true","rr-logo-small": APP_SETTINGS.isRollsRoyce === "true"}'>
                    </div>
                    <div class="bmw-header-sm-technical-information">Technical Information System</div>
                  </div>
                </div>
                <div class="col-sm-2" style="margin-top:6px; text-align:right">
                  <button *ngIf='!hideNavbar' (click)="hideShowSearchInMobile()" [style]="setBackgroundStyle"
                    class="btn bmw-header-xs-dropdown" type="submit" style="outline-style:none;">
                    <i *ngIf="!hideShowSearchFlag" class="material-icons md-10">search</i>
                    <i *ngIf="hideShowSearchFlag" class="glyphicon glyphicon-remove"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse navbar-collapse bmw-navbar-sm-content-size">
            <ul *ngIf='!hideNavbar' class="nav navbar-nav" id="accordionSM">
              <li (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a routerLink="/home">
                      <span class="bmw-navbar-sm-content-header"> Home </span>
                    </a>
                  </div>
                </div>
              </li>
              <li>
                <div class="panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordionSM" href="#collapseServiceInformation">
                        <span class="bmw-navbar-sm-content-header"> Service Information </span>
                        <span class="caret"></span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapseServiceInformation" class="panel-collapse collapse">
                    <ul class="list-group" style="margin:10px">
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/sib-home"]'>
                          <span class="bmw-navbar-sm-content-list">Service Bulletins</span>
                        </a>
                      </li>
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/tri-home"]'>
                          <span class="bmw-navbar-sm-content-list">{{bulletinLabel}}</span>
                        </a>
                      </li>
                      <li (click)='toggleNavbarCollapse()'
                        *ngIf="APP_SETTINGS.isMINI == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
                        <a [routerLink]='["/operating-fluid"]'>
                          <span class="bmw-navbar-sm-content-list">Operating Fluids</span>
                        </a>
                      </li>
                      <li *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/obd"]'>
                          <span class="bmw-navbar-sm-content-list">OBD</span>
                        </a>
                      </li>
                      <li *ngIf="APP_SETTINGS.isRollsRoyce == 'false' && APP_SETTINGS.isMOTORRAD == 'false'" (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/legacy"]'>
                          <span class="bmw-navbar-sm-content-list">Legacy</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <div class="panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordionSM" href="#collapsePartsInformation">
                        <span class="bmw-navbar-sm-content-header"> Parts Information </span>
                        <span class="caret"></span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapsePartsInformation" class="panel-collapse collapse">
                    <ul class="list-group" style="margin:10px">
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/parts-home"]'>
                          <span class="bmw-navbar-sm-content-list">Parts Bulletin</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <div class="panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordionSM" href="#collapseTraining">
                        <span class="bmw-navbar-sm-content-header"> Training </span>
                        <span class="caret"></span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapseTraining" class="panel-collapse collapse">
                    <ul class="list-group" style="margin:10px">
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]="['/tech-training-manual']">
                          <span class="bmw-navbar-sm-content-list">Technical Training Manuals</span>
                        </a>
                      </li>
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]="['/body-paint-manual']">
                          <span class="bmw-navbar-sm-content-list">Body & Paint Manuals</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <div class="panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordionSM" href="#collapseToolsEquipment">
                        <span class="bmw-navbar-sm-content-header">Tools & Equipment </span>
                        <span class="caret"></span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapseToolsEquipment" class="panel-collapse collapse">
                    <ul class="list-group" style="margin:10px">
                      <li (click)='toggleNavbarCollapse()'>

                        <a [routerLink]='["/equip-manual"]'>
                          <span class="bmw-navbar-sm-content-list">Equipment Manuals</span>
                        </a>
                      </li>
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/tool-report"]'>
                          <span class="bmw-navbar-sm-content-list">Tool Report</span>
                        </a>
                      </li>
                      <li (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/faq"]'>
                          <span class="bmw-navbar-sm-content-list">FAQ & Top Links</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a routerLink="/videos">
                      <span class="bmw-navbar-sm-content-header"> Videos </span>
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf='isCar' (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a [routerLink]='["/takata-recall"]'>
                      <span class="bmw-navbar-sm-content-header"> Takata Recall </span>
                    </a>
                  </div>
                </div>
              </li>


              <li *ngIf="isExternal == 'true'">

                <div class="panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordionSM" href="#collapseAOS">
                        <span class="bmw-navbar-sm-content-header">AOS </span>
                        <span class="caret"></span>
                      </a>
                    </h4>
                  </div>
                  <div id="collapseAOS" class="panel-collapse collapse">
                    <ul class="list-group" style="margin:10px">

                      <li *ngFor="let item of ossLinks; let i = index" (click)='toggleNavbarCollapse()'>
                        <a [routerLink]='["/oss"]' [queryParams]='{ossLinkName : item.linkName, ossLink: item.linkURL}'>
                          <span class="bmw-navbar-sm-content-list">{{item.linkName}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </li>

              <li *ngIf="isExternal == 'false'" (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a [routerLink]='["/tech-doc"]'>
                      <span class="bmw-navbar-sm-content-header"> Technical Documentation </span>
                    </a>
                  </div>
                </div>
              </li>

              <div class="bmw-vertical-space"></div>
              <div class="bmw-vertical-space"></div>
              <li (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a [routerLink]='["/model-map"]'>
                      <span class="bmw-navbar-sm-content-header"> Model Map </span>
                    </a>
                  </div>
                </div>
              </li>
              <li (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a [routerLink]='["/profile"]'>
                      <span class="bmw-navbar-sm-content-header"> Profile </span>
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf="isExternal == 'true'" (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a [routerLink]='["/logout"]' (click)='clearUserSessions()'>
                      <span class="bmw-navbar-sm-content-header"> Log Out </span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <ul *ngIf='hideNavbar' class="nav navbar-nav" id="accordionSM">
              <li (click)='toggleNavbarCollapse()'>
                <div class="panel-default">
                  <div class="panel-heading">
                    <a routerLink="/login">
                      <span class="bmw-navbar-sm-content-header"> Login </span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div *ngIf="hideShowSearchFlag" class="col-sm-12 row bmw-no-gutter" [style]="setBackgroundStyle"
          style="height:70px;margin-top:-1px">
          <div class="col-sm-2 bmw-no-gutter"></div>
          <div class="col-sm-8 bmw-no-gutter" style="padding-top:10px;padding-left:0px;">
            <div class="dropdown bmw-no-gutter" style="float: left;padding-top:7px;">
              <div class="btn dropdown-toggle bmw-header-md-dropdown" data-toggle="dropdown" style="height:42px;padding: 5px 10px 5px 8px;
              line-height: 2;">{{searchSectionDisplay}}&nbsp;
                <span class="caret"></span>
              </div>
              <ul class="dropdown-menu bmw-dropdown-background" style="width:300px">

                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('SIB')">
                    <div class="col-sm-10">Service Bulletins (SIB)</div>
                    <div class="col-sm-2">
                      <input type="radio" value="sib">
                    </div>
                  </div>

                </li>
                <li>
                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TM')">
                    <div class="col-sm-10">Training Manuals (TM)</div>
                    <div class="col-sm-2">
                      <input type="radio" value="tm">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('FAQ')">
                    <div class="col-sm-10">FAQ & Top Links (FAQ)</div>
                    <div class="col-sm-2">
                      <input type="radio" value="faq">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('OBD')">
                    <div class="col-sm-10">OBD</div>
                    <div class="col-sm-2">
                      <input type="radio" value="obd">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TE')">
                    <div class="col-sm-10">Tools & Equipment (T&E)</div>
                    <div class="col-sm-2">
                      <input type="radio" value="te">
                    </div>
                  </div>

                </li>
                <li *ngIf="isExternal == 'false'">

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TD')">
                    <div class="col-sm-10">Technical Documentation (TD)</div>
                    <div class="col-sm-2">
                      <input type="radio" value="td">
                    </div>
                  </div>
                </li>
                <li>
                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('All')">
                    <div class="col-sm-9">All</div>
                    <div class="col-sm-2 bmw-no-gutter">
                      <input type="radio" checked="checked" value="all">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-sm-11 bmw-no-gutter navbar-form" role="search">
              <form class="input-group" name="searchBulletins">
                <input type="text" class="form-control" style="height: 40px;" size=48 [(ngModel)]='search_key'
                  (keyup.enter)="searchKeyword(search_section)" placeholder="Search" name="srch-term" id="srch-term3"
                  minlength="1">
                <div class="input-group-btn">
                  <button class="btn btn-default bmw-header-sm-dropdown" style="background-color:#4a4a4a" type="button"
                    (click)="searchKeyword(search_section)" [disabled]='search_key?.trim().length < 1'>
                    <i class="material-icons md-10">search</i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="col-sm-2 bmw-no-gutter"></div>

        </div>

      </div>
    </div>
    <div *ngIf='screenWidth < 767'>
      <div (window:resize)="screenRotate($event)" (window:orientationchange)="screenRotate($event)">

        <nav class="navbar" role="navigation" style="margin:0px">
          <div class="container-fluid navbar-inner">
            <div class="navbar-header">
              <button *ngIf='!hideNavbar' type="button" class="navbar-toggle pull-left" data-toggle="collapse" #navbar
                data-target=".navbar-collapse">
                <span class="icon-bar" style="background-color:white"></span>
                <span class="icon-bar" style="background-color:white"></span>
                <span class="icon-bar" style="background-color:white"></span>
              </button>
              <div class="bmw-header-xs-rectangle" [style]="setBackgroundStyle">
                <div class="col-xs-3"></div>
                <div>
                  <div class="navbar-brand bmw-header-xs-logo"
                    [ngClass]='{"mini-logo-small": APP_SETTINGS.isMINI === "true","rr-logo-small": APP_SETTINGS.isRollsRoyce === "true"}'>
                  </div>
                  <div class="bmw-header-xs-technical-information">TIS</div>
                </div>
                <div class="col-xs-2" style="float:right;margin-right:5px;margin-top:-25px;">
                  <button *ngIf='!hideNavbar' (click)="hideShowSearchInMobile()" class="btn bmw-header-xs-dropdown"
                    [style]="setBackgroundStyle" type="submit" style="outline-style:none;">
                    <i *ngIf="!hideShowSearchFlag" class="material-icons md-10">search</i>
                    <i *ngIf="hideShowSearchFlag" class="glyphicon glyphicon-remove"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="navbar-collapse collapse bmw-navbar-xs-content-size">
              <ul *ngIf='!hideNavbar' class="nav navbar-nav">
                <li (click)='toggleNavbarCollapse()'>
                  <a routerLink="/home">
                    <span class="bmw-navbar-xs-content-header">Home</span>
                  </a>
                </li>
                <li class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                    <span class="bmw-navbar-xs-content-header">Service Information</span>
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/sib-home"]'>
                        <span class="bmw-navbar-xs-content-list">Service Bulletins</span>
                      </a>
                    </li>
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/tri-home"]'>
                        <span class="bmw-navbar-xs-content-list">{{bulletinLabel}}</span>
                      </a>
                    </li>
                    <li (click)='toggleNavbarCollapse()'
                      *ngIf="APP_SETTINGS.isMINI == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
                      <a [routerLink]='["/operating-fluid"]'>
                        <span class="bmw-navbar-xs-content-list">Operating Fluids</span>
                      </a>
                    </li>
                    <li *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/obd"]'>
                        <span class="bmw-navbar-xs-content-list">OBD</span>
                      </a>
                    </li>
                    <li *ngIf="APP_SETTINGS.isRollsRoyce == 'false' && APP_SETTINGS.isMOTORRAD == 'false'" (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/legacy"]'>
                        <span class="bmw-navbar-xs-content-list">Legacy</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li *ngIf="isExternal == 'false'" class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                    <span class="bmw-navbar-xs-content-header">Parts Information</span>
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/parts-home"]'>
                        <span class="bmw-navbar-xs-content-list">Parts Bulletins</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                    <span class="bmw-navbar-xs-content-header">Training</span>
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/tech-training-manual"]'>
                        <span class="bmw-navbar-xs-content-list">Technical Training Manuals</span>
                      </a>
                    </li>
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/body-paint-manual"]'>
                        <span class="bmw-navbar-xs-content-list">Body & Paint Manuals</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                    <span class="bmw-navbar-xs-content-header">Tools & Equipment</span>
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)='toggleNavbarCollapse()'>

                      <a [routerLink]='["/equip-manual"]'>
                        <span class="bmw-navbar-xs-content-list">Equipment Manuals</span>
                      </a>
                    </li>
                    <li (click)='toggleNavbarCollapse()'>

                      <a [routerLink]='["/tool-report"]'>
                        <span class="bmw-navbar-xs-content-list">Tool Report</span>
                      </a>
                    </li>
                    <li (click)='toggleNavbarCollapse()'>
                      <a [routerLink]='["/faq"]'>
                        <span class="bmw-navbar-xs-content-list">FAQ & Top Links</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li (click)='toggleNavbarCollapse()'>
                  <a routerLink="/videos">
                    <span class="bmw-navbar-xs-content-header">Videos</span>
                  </a>
                </li>
                <li *ngIf='isCar' (click)='toggleNavbarCollapse()'>
                  <a [routerLink]='["/takata-recall"]'>
                    <span class="bmw-navbar-xs-content-header">Takata Recall</span>
                  </a>
                </li>

                <li *ngIf="isExternal == 'false'" (click)='toggleNavbarCollapse()'>
                  <a [routerLink]='["/tech-doc"]'>
                    <span class="bmw-navbar-xs-content-header">Technical Documentation</span>
                  </a>
                </li>

                <hr />

                <li (click)='toggleNavbarCollapse()'>
                  <a [routerLink]='["/model-map"]'>
                    <span class="bmw-navbar-xs-content-header">Model Map</span>
                  </a>
                </li>
                <li (click)='toggleNavbarCollapse()'>
                  <a [routerLink]='["/profile"]'>
                    <span class="bmw-navbar-xs-content-header">Profile</span>
                  </a>
                </li>
                <li *ngIf="isExternal == 'true'" (click)='toggleNavbarCollapse()'>
                  <a [routerLink]='["/logout"]' (click)='clearUserSessions()'>
                    <span class="bmw-navbar-xs-content-header">Log Out</span>
                  </a>
                </li>
              </ul>
              <ul *ngIf='hideNavbar' class="nav navbar-nav">
                <li (click)='toggleNavbarCollapse()'>
                  <div class="panel-default">
                    <div class="panel-heading">
                      <a routerLink="/login">
                        <span class="bmw-navbar-sm-content-header"> Login </span>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </nav>

        <div *ngIf="hideShowSearchFlag" class="col-xs-12 row bmw-no-gutter" [style]="setBackgroundStyle"
          style="height:60px;margin-top:-1px">
          <div class="col-xs-1 bmw-no-gutter"></div>
          <div class="col-xs-10 bmw-no-gutter" style="padding-top:10px;padding-left:5px;">
            <div class="dropdown bmw-no-gutter" style="float: left;">
              <div class="btn dropdown-toggle bmw-header-md-dropdown" data-toggle="dropdown">
                {{searchSectionDisplay}}&nbsp;
                <span class="caret"></span>
              </div>
              <ul class="dropdown-menu bmw-dropdown-background" style="width:300px">

                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('SIB')">
                    <div class="col-xs-10">Service Bulletins (SIB)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="sib">
                    </div>
                  </div>

                </li>
                <li>
                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TM')">
                    <div class="col-xs-10">Training Manuals (TM)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="tm">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('FAQ')">
                    <div class="col-xs-10">FAQ & Top Links (FAQ)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="faq">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('OBD')">
                    <div class="col-xs-10">OBD</div>
                    <div class="col-xs-2">
                      <input type="radio" value="obd">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TE')">
                    <div class="col-xs-10">Tools & Equipment (T&E)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="te">
                    </div>
                  </div>

                </li>
                <li *ngIf="isExternal == 'false'">

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TD')">
                    <div class="col-xs-10">Technical Documentation (TD)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="td">
                    </div>
                  </div>

                </li>
                <li *ngIf='isCar'>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('TKR')">
                    <div class="col-xs-10">Takata Recall (TKR)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="tkr">
                    </div>
                  </div>

                </li>
                <li>

                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('LGC')">
                    <div class="col-xs-10">Legacy (LGC)</div>
                    <div class="col-xs-2">
                      <input type="radio" value="lgc">
                    </div>
                  </div>

                </li>
                <li>
                  <div class="pointer bmw-lg-dropdown-radio" (click)="selectValue('All')">
                    <div class="col-xs-9">All</div>
                    <div class="col-xs-2 bmw-no-gutter">
                      <input type="radio" checked="checked" value="all">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="bmw-no-gutter" role="search">
              <form class="input-group" name="searchBulletins">
                <input type="text" class="form-control" [(ngModel)]='search_key'
                  (keyup.enter)="searchKeyword(search_section)" placeholder="Search" name="srch-term" id="srch-term4">

                <div class="input-group-btn">
                  <button class="btn btn-default bmw-header-lg-dropdown" type="button"
                    (click)="searchKeyword(search_section)" [disabled]='search_key?.trim().length < 1'>
                    <i class="material-icons md-10">search</i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>